import React, { useState } from "react";
import { lensPath } from "ramda";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import { set } from "ramda";
import Grid from "@material-ui/core/Grid";
import { notBlank } from "../../util/ext";
import { useContentProviderCreate } from "../organizationServices";
import {
  validateContentProvider,
  validateContentProviderField,
} from "../organizationValidation";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/styles";
import { useErrorBox } from "./use-errorBox";

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: "1.8rem",
  },
}));

const ContentProviderDialog = ({ organizationId, open, onCancel, onSave }) => {
  const classes = useStyles();
  const [fields, setFields] = useState({
    contentProviderId: null,
  });

  const {
    addValidationError,
    removeValidationError,
    setValidationErrors,
    setGeneralError,
    hasValidationError,
    firstValidationError,
    ErrorBox: DialogErrors,
  } = useErrorBox();

  const handleTextChange = path => event => {
    const value = event.target.value;
    setFields(prev => set(lensPath(path), value, prev));
  };

  const handleBlur = (field, value) => {
    const validationErrors = validateContentProviderField(field, value);
    if (notBlank(validationErrors)) {
      addValidationError(validationErrors);
    } else {
      removeValidationError(field);
    }
  };

  const contentProviderCreate = useContentProviderCreate();
  const handleApply = async () => {
    const validationErrors = validateContentProvider(fields);
    if (notBlank(validationErrors)) {
      setValidationErrors(validationErrors);
    } else {
      try {
        await contentProviderCreate.mutateAsync({
          resourceIds: {
            orgId: organizationId,
            contentProviderId: fields.contentProviderId,
          },
        });
        onSave(fields);
      } catch (err) {
        setGeneralError(err);
      }
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="form-dialog-title">New Content Provider</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter the Content Provider Id from RIP
        </DialogContentText>
        <DialogErrors />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              id="content-provider-id"
              fullWidth
              label="Content Provider Id"
              InputProps={{
                classes: { root: classes.title },
              }}
              value={fields.contentProviderId}
              onChange={handleTextChange(["contentProviderId"])}
              error={hasValidationError("contentProviderId")}
              helperText={firstValidationError("contentProviderId")}
              onBlur={() =>
                handleBlur("contentProviderId", fields.contentProviderId)
              }
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContentProviderDialog;
